import React from 'react';
import { Box, Typography } from '@mui/material';
import { EventNote as EventNoteIcon } from '@mui/icons-material';
import DoctorShiftRuleListContainer from './container/DoctorShiftRuleListContainer';
import { doctorShiftRuleRepository } from '../../../infrastructure/repositories/DoctorShiftRuleRepositoryImpl';
import { PageContainer, TitleArea } from './DoctorShiftRuleList.styles';

/**
 * 医師シフトルール一覧ページ
 *
 * - ページタイトル「医師シフトルール」
 * - レイアウト統合
 * - Container組み込み
 */
export const DoctorShiftRuleListPage: React.FC = () => {
  return (
    <PageContainer>
      {/* ページタイトル */}
      <Box sx={{ mb: 3 }}>
        <TitleArea>
          <EventNoteIcon color="primary" sx={{ fontSize: 32 }} />
          <Typography variant="h5" fontWeight={600}>
            医師シフトルール
          </Typography>
        </TitleArea>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          医師ごとのシフトルール（割り当て可能/禁止時間帯）を管理します
        </Typography>
      </Box>

      {/* コンテナ */}
      <DoctorShiftRuleListContainer repository={doctorShiftRuleRepository} />
    </PageContainer>
  );
};

export default DoctorShiftRuleListPage;
